// Shared "Autumn AI" glyph — white leaf behind animated cream + amber sparks.
// Used by the desktop floating launcher and the mobile header button so both
// read identically. Needs a `data-design="refined-teal"` ancestor for the kit
// classes (.a-spark-cluster / .a-leaf / .a-spark-*) to resolve.
export const AssistantSparkCluster = () => (
  <span className="a-spark-cluster" aria-hidden>
    <svg
      className="a-leaf"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.699261 22V16.7306L11.1882 8.62385L0.499472 14.1973C0.0998943 13.4676 0 12.1368 0 11.5625C0.479492 5.1582 4.32875 2.13844 6.19344 1.42911C10.6687 -0.759718 18.5138 0.0442028 21.8768 0.719766C22.756 5.25955 18.7136 8.01585 16.5824 8.82652H20.6781C20.2786 12.1503 16.0497 13.7919 13.9852 14.1973H18.3806C17.3416 16.386 15.1506 18.0141 14.185 18.5547C10.7486 20.9056 5.4276 20.0071 3.19662 19.264V22H0.699261Z"
        fill="currentColor"
      />
    </svg>
    <svg className="a-spark-big-svg" viewBox="1.5 2 17 16" fill="none">
      <path
        className="a-spark-big"
        fill="currentColor"
        d="M11.5 2c.18 1.94.92 3.6 2.22 4.9 1.3 1.3 2.96 2.04 4.9 2.22-1.94.18-3.6.92-4.9 2.22-1.3 1.3-2.04 2.96-2.22 4.9-.18-1.94-.92-3.6-2.22-4.9-1.3-1.3-2.96-2.04-4.9-2.22 1.94-.18 3.6-.92 4.9-2.22C10.58 5.6 11.32 3.94 11.5 2Z"
      />
    </svg>
    <svg className="a-spark-sm-svg" viewBox="1.5 12 7 7" fill="none">
      <path
        className="a-spark-sm"
        fill="currentColor"
        d="M5 12c.1 1.05.5 1.95 1.2 2.65.7.7 1.6 1.1 2.65 1.2-1.05.1-1.95.5-2.65 1.2-.7.7-1.1 1.6-1.2 2.65-.1-1.05-.5-1.95-1.2-2.65-.7-.7-1.6-1.1-2.65-1.2 1.05-.1 1.95-.5 2.65-1.2C4.5 13.95 4.9 13.05 5 12Z"
      />
    </svg>
  </span>
);
